import React from 'react';

const HomePropertyCardSkeleton = () => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
        <div className="h-48 sm:h-52 bg-gray-200 animate-pulse rounded-t-xl"></div>
    
        <div className="p-3 space-y-3">
          <div className="h-5 bg-gray-300 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-full"></div>
    
          <div className="flex justify-between items-center pt-2">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
        </div>
      </div>
  );
};

export default HomePropertyCardSkeleton;